import { useRef } from 'react'
import Add from '@mui/icons-material/Add'
import { Button } from '@mui/material'
import useOverlay from '@/hooks/useOverlay'
import { ProjectLinkedModel } from '@/types/project-linked-models'
import AddModelMenu from './AddModelMenu'

type AddModelButtonProps = {
  projectLinkedModels: ProjectLinkedModel[]
  disabled?: boolean
}

export default function AddModelButton({
  projectLinkedModels,
  disabled,
}: AddModelButtonProps) {
  const addOverlay = useOverlay()
  const anchorElRef = useRef<HTMLButtonElement>(null)

  return (
    <>
      <Button
        ref={anchorElRef}
        variant="text"
        startIcon={<Add />}
        onClick={addOverlay.open}
        disabled={disabled}
      >
        Add model
      </Button>

      <AddModelMenu
        overlay={addOverlay}
        anchorEl={anchorElRef.current}
        projectLinkedModels={projectLinkedModels}
      />
    </>
  )
}
